import { Component, h, Host, Element, Prop } from "@stencil/core";

@Component({
  tag: "f-header",
  styleUrl: "f-header.scss",
  shadow: true,
})
export class Header {
  @Element() el: HTMLFHeaderElement;

  @Prop() subbrandIdentifier?: string;

  render() {
    return (
      <Host>
        <header class="o-header">
          <div class="o-header__top-container">
            <div class="l-page-row">
              <div class="o-header__top">
                <div class="o-header__logo-container">
                  <slot name="header-logo" />
                </div>
                <div class="o-header__quicklinks-container">
                  <slot name="header-quicklinks" />
                </div>
                <div class="o-header__search-container">
                  <slot name="header-search" />
                </div>
              </div>
            </div>
          </div>
          <div class="o-header__search-suggestions-wrapper">
            <slot name="header-search-suggestions" />
          </div>
          <div class="o-header__mid-container">
            <div class="l-page-row">
              <div class="o-header__mid">
                <div class="o-header__navigation-container">
                  <slot name="header-navigation" />
                </div>
                <div class="o-header__subbrand-container">
                  {Boolean(this.subbrandIdentifier) ? (
                    <p class="o-header__subbrand">{this.subbrandIdentifier}</p>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
          <slot name="header-maintenance" />
          <div class="o-header__bottom-container">
            <div class="l-page-row">
              <div class="o-header__bottom">
                <div class="o-header__breadcrumbs-container">
                  <slot name="header-breadcrumbs" />
                </div>
                <div class="o-header__impersonate-container">
                  <slot name="header-bottom" />
                </div>
              </div>
            </div>
          </div>
        </header>
      </Host>
    );
  }
}
